export const GET_DIMENSIONS_WATCHER =
  "app/WidgetResultByDimensionEngagementAmbassador/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/WidgetResultByDimensionEngagementAmbassador/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/WidgetResultByDimensionEngagementAmbassador/GET_DIMENSIONS_FAILED"
